/**
 * Helper to make sure we check every style prop and exclude it when passing props to DOM.
 * https://stackoverflow.com/a/60132060/5253897
 * */
export const allUnionValues =
	<T>() =>
	<U extends T[]>(array: U & ([T] extends [U[number]] ? unknown : 'Invalid')) =>
		array;
